import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../../app/i18n";
import { SiteDetailPage } from "../../../../areas/seller/sites/SiteDetailPage";

export const Route = createFileRoute("/app/_seller/sites/$siteId")({
  beforeLoad: () => loadNamespaces("sites"),
  component: SiteDetailPage,
});
